import { useState } from "react";
import { toast } from "sonner";
import { Loader2, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import adminApi from "@/lib/adminApi";

// Eliminación de equipos (iPhone Nuevos / Usados). El backend valida operaciones vinculadas.
export function DeleteDeviceDialog({ kind, item, onClose, onDeleted }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const path = kind === "used" ? `/admin/inventory/${item.id}` : `/admin/new-iphones/${item.id}`;
  const del = async () => {
    if (!reason.trim()) { toast.error("Indica un motivo de eliminación"); return; }
    setSaving(true);
    try {
      await adminApi.delete(path, { data: { reason: reason.trim() } });
      toast.success("Equipo eliminado");
      onDeleted?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo eliminar");
    } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="delete-device-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-rose-600"><AlertTriangle className="w-5 h-5" /> Eliminar equipo</DialogTitle>
          <DialogDescription>Esta acción es irreversible. El registro operativo se elimina; las operaciones vinculadas (si existieran) bloquean la eliminación.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="rounded-xl border border-zinc-200 bg-zinc-50 p-3 text-sm space-y-1">
            <div className="flex justify-between"><span className="text-zinc-500">Modelo</span><span className="font-semibold text-zinc-900" data-testid="del-model">{item.model} {item.capacity}</span></div>
            <div className="flex justify-between"><span className="text-zinc-500">ID</span><span className="font-mono text-zinc-800" data-testid="del-id">{item.id}</span></div>
            <div className="flex justify-between"><span className="text-zinc-500">IMEI</span><span className="font-mono text-zinc-800" data-testid="del-imei">{item.imei || "—"}</span></div>
            <div className="flex justify-between"><span className="text-zinc-500">Dueño</span><span className="text-zinc-800" data-testid="del-owner">{item.owner_name || "—"}</span></div>
          </div>
          <label className="flex flex-col gap-0.5"><span className="text-[11px] text-zinc-500 px-1">Motivo de eliminación *</span>
            <Input data-testid="del-reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ej: cargado por error" className="h-10 rounded-xl" /></label>
          <div className="flex gap-2 pt-1">
            <Button variant="outline" onClick={onClose} className="h-11 rounded-xl flex-1" data-testid="del-cancel">Cancelar</Button>
            <Button onClick={del} disabled={saving || !reason.trim()} className="h-11 rounded-xl flex-1 bg-rose-600 hover:bg-rose-700" data-testid="del-confirm">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Eliminar definitivamente"}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
